import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Collapse from '@mui/material/Collapse';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { useDispatch, useSelector } from 'react-redux';

import ChevronDown from '@gef-ui/material-icons/ChevronDown';
import ChevronUp from '@gef-ui/material-icons/ChevronUp';

import { codelists } from 'constants/codelists';
import {
	fetchInProgressAndAfterDeadLineLeadsByType,
	setSelectedInProgressTaskTypeId,
} from 'features/views/marketPlace/actions';
import { generateLeadIcon } from 'features/views/marketPlace/utils';
import { getCodelistByName, getCodelistPropById } from 'utils';

import SubTableInProgressAndAfterDeadline from './SubTableInProgressAndAfterDeadline';

const TableRowInProgressAndAfterDeadline = ({ record, isDetailVisible, onDetailVisibilityChange }) => {
	const dispatch = useDispatch();
	const taskTypesCodelist = useSelector(getCodelistByName(codelists.taskTypes));

	const handleOpenSubTable = useCallback(
		(taskTypeId) => (e) => {
			e.stopPropagation();
			onDetailVisibilityChange();
			dispatch(setSelectedInProgressTaskTypeId(taskTypeId));
			dispatch(fetchInProgressAndAfterDeadLineLeadsByType(taskTypeId));
		},
		[dispatch, onDetailVisibilityChange],
	);

	const handleCloseSubTable = useCallback(
		(e) => {
			e.stopPropagation();
			onDetailVisibilityChange();
		},
		[onDetailVisibilityChange],
	);

	return (
		<>
			<TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
				<TableCell width={65}>
					{generateLeadIcon({
						taskTypeId: record?.taskTypeId,
						width: 35,
						height: 35,
					})}
				</TableCell>
				<TableCell width={250}>{getCodelistPropById(record?.taskTypeId, taskTypesCodelist)}</TableCell>
				<TableCell colSpan={5}>{record?.taskCount}</TableCell>
				<TableCell align="right" sx={{ borderBottom: 'none' }}>
					{isDetailVisible ? (
						<ChevronUp
							sx={{ color: 'primary.main', cursor: 'pointer' }}
							id="toggleIcon"
							onClick={handleCloseSubTable}
						/>
					) : (
						<ChevronDown
							sx={{ color: 'primary.main', cursor: 'pointer' }}
							id="toggleIcon"
							onClick={handleOpenSubTable(record.taskTypeId)}
						/>
					)}
				</TableCell>
			</TableRow>
			<TableRow>
				<TableCell sx={{ p: 0 }} colSpan={8}>
					<Collapse in={isDetailVisible} unmountOnExit>
						<SubTableInProgressAndAfterDeadline taskTypeId={record.taskTypeId} />
					</Collapse>
				</TableCell>
			</TableRow>
		</>
	);
};

TableRowInProgressAndAfterDeadline.propTypes = {
	isDetailVisible: PropTypes.bool,
	onDetailVisibilityChange: PropTypes.func,
	record: PropTypes.object,
};

export default TableRowInProgressAndAfterDeadline;
